export default {
  computed:{
    areaRoute () {
      return `/${this.accessedArea}`
    },
    areaRouteCreate () {
      return `${this.accessedArea}/create`
    },
    permissionCreate () {
      return `${this.accessedArea}-create`
    }
  },
  methods: {
    setOnFocus (inputName) {
      const inputEl = this.$refs[inputName].$el.querySelector('input')
      inputEl.focus()
    }
  }
}
